module.exports = __webpack_public_path__ + "media/images/emblems/Aegerten-coat_of_arms-03ba2b09bb64c003ca71e641186ed451.svg";